import React from 'react';
import { Box } from '@chakra-ui/react';
import AnimatedLine from './AnimatedLine';

const AnimatedRadialLines = ({
  x,
  y,
  innerDiamater,
  outerDiameter,
  color,
  lineWidth,
}) => {
  return (
    <Box position="relative" width="100%" height="100%">
      <svg width="100%" height="100%" style={{ position: 'relative' }}>
        {/* North Line */}
        <AnimatedLine
          startX={x}
          startY={y - innerDiamater}
          endX={x}
          endY={y - outerDiameter}
          color={color}
          radius={lineWidth}
        />
        {/* NorthEast Line */}
        <AnimatedLine
          startX={innerDiamater * Math.cos(Math.PI * 1.75) + x}
          startY={innerDiamater * Math.sin(Math.PI * 1.75) + y}
          endX={outerDiameter * Math.cos(Math.PI * 1.75) + x}
          endY={outerDiameter * Math.sin(Math.PI * 1.75) + y}
          color={color}
          radius={lineWidth}
        />
        {/* East Line */}
        <AnimatedLine
          startX={x + innerDiamater}
          startY={y}
          endX={x + outerDiameter}
          endY={y}
          color={color}
          radius={lineWidth}
        />
        {/* SouthEast Line */}
        <AnimatedLine
          startX={innerDiamater * Math.cos(Math.PI * 0.25) + x}
          startY={innerDiamater * Math.sin(Math.PI * 0.25) + y}
          endX={outerDiameter * Math.cos(Math.PI * 0.25) + x}
          endY={outerDiameter * Math.sin(Math.PI * 0.25) + y}
          color={color}
          radius={lineWidth}
        />
        {/* South Line */}
        <AnimatedLine
          startX={x}
          startY={y + innerDiamater}
          endX={x}
          endY={y + outerDiameter}
          color={color}
          radius={lineWidth}
        />
        {/* SouthWest Line */}
        <AnimatedLine
          startX={innerDiamater * Math.cos(Math.PI * 0.75) + x}
          startY={innerDiamater * Math.sin(Math.PI * 0.75) + y}
          endX={outerDiameter * Math.cos(Math.PI * 0.75) + x}
          endY={outerDiameter * Math.sin(Math.PI * 0.75) + y}
          color={color}
          radius={lineWidth}
        />
        {/* West Line */}
        <AnimatedLine
          startX={x - innerDiamater}
          startY={y}
          endX={x - outerDiameter}
          endY={y}
          color={color}
          radius={lineWidth}
        />
        {/* NorthWest Line */}
        <AnimatedLine
          startX={innerDiamater * Math.cos(Math.PI * 1.25) + x}
          startY={innerDiamater * Math.sin(Math.PI * 1.25) + y}
          endX={outerDiameter * Math.cos(Math.PI * 1.25) + x}
          endY={outerDiameter * Math.sin(Math.PI * 1.25) + y}
          color={color}
          radius={lineWidth}
        />
      </svg>
    </Box>
  );
};
export default AnimatedRadialLines;
